import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "C:/nexus/data-gh/guide/src/components/layout/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const SubmodulesTable = makeShortcode("SubmodulesTable");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`D3 Importing submodules`}</h1>
    <p>{`When we're using D3, we don't use every single function that's available in the package. In order to reduce file size, we should import the specific functions that we are using.`}</p>
    <p>{`If you look for code online, often you'll see code such as:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`d3.select("...")
`}</code></pre>
    <p>{`Whenever there is a `}<inlineCode parentName="p">{`d3.`}</inlineCode>{`, this means we can just import the following function name and call it without the `}<inlineCode parentName="p">{`d3.`}</inlineCode>{`.`}</p>
    <p>{`For example, instead of the code above we would do:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import { select } from "d3-selection";

select("...")
`}</code></pre>
    <p>{`In this example, "d3-selection" is a submodule as the entire D3 package is split into these submodules. If you ever don't know the name of the submodule that function comes from, you can google something like: 'd3 select' and the first link will be to the d3 github, '`}<a parentName="p" {...{
        "href": "https://github.com/d3/d3-selection'"
      }}>{`https://github.com/d3/d3-selection'`}</a>{` and you can tell that the 'select' function is from 'd3-selection' since that is the last part of the url.`}</p>
    <p>{`If you're using a submodule hat's not listed in the `}<inlineCode parentName="p">{`package.json`}</inlineCode>{`, you can install new packages using the following command:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm install --save packageNameHere
`}</code></pre>
    <h2>{`Common functions and their submodules`}</h2>
    <SubmodulesTable mdxType="SubmodulesTable">
    <thead>
        <tr>
            <th>Function Names</th>
            <th>Submodules</th>
        </tr>
    </thead>
    <tbody>
        <tr>
            <td>select, selectAll</td>
            <td>d3-selection</td>
        </tr>
        <tr>
            <td>axisLeft, axisBottom</td>
            <td>d3-axis</td>
        </tr>
        <tr>
            <td>max, extent</td>
            <td>d3-array</td>
        </tr>
        <tr>
            <td>scaleLinear, scaleBand</td>
            <td>d3-scale</td>
        </tr>
        <tr>
            <td>line, area</td>
            <td>d3-shape</td>
        </tr>
        <tr>
            <td>nest</td>
            <td>d3-collection</td>
        </tr>
    </tbody>
    </SubmodulesTable>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      